import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19 29.5C19 23.7 25.044 18 32.5 18S46 23.7 46 29.5 39.956 40 32.5 40 19 35.3 19 29.5z",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24.153 36.156c-4.237-3.978-4.52-10.43-.658-14.372 3.827-3.905 9.38-3.72 13.432.062.464.433 2.02 4.353 2.386 4.841l7.312-.125c-.398-.462-3.563-8.312-4.688-9.187-7.27-5.654-17.093-6.528-23.312-.25-6.314 6.374-5.74 17.09 1.168 23.56 6.112 5.725 15.14 6.262 21.357 1.75l.136.078 4.534 3.547-.5-5.81-.02-6.628-7.36-.066-7.526-1.194 5.204 4.66c.537.05.474.256.82.54-3.824 2.462-8.66 1.996-12.285-1.406z",
      fill: "#55acba"
    }, null, -1),
    _createElementVNode("path", {
      d: "M46.075 28.13C45.79 19.216 38.39 11.99 29.55 11.99S12.903 19.338 13.188 28.25c.032.99.688 7.938 4.563 11.938L11 47c-4.063-4.125-8.87-13.995-6.75-24.813C6.063 12.938 14.916 2 29.23 2s26.293 11.698 26.756 26.13c.41 12.8-8.255 24.377-20.236 26.62v7.47L18.375 52l17.25-16.563s.026 8.028 0 8.72c7.014-1.676 10.695-8.39 10.45-16.028z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1),
    _createElementVNode("path", {
      d: "M40.938 41.125l.348.388 6.214 4.362-1.375-16.125-16.5.625s5.94 5.886 6.285 6.17c-.02.064-.068-.048-.19.486-.095.407.31 6.314.28 6.282.03-.03 2.506-.684 4.938-2.187z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1)
  ])))
}
export default { render: render }